import React from 'react';

function ScoringTutorial() {
  return (
    <div className="tutorial-section" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#495057', marginBottom: '15px' }}>🚀 进行刷分</h3>
      
      <div className="tutorial-steps">
        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤1: 开始刷分操作</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            前面的授权、配置等步骤完成后，就可以开始刷分了。
            <br/>
            首先阅读刷分策略附近的文本, 按照信息在手机端进行购买的配置
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/start-scoring.png"
              alt="开始刷分"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              gap: '10px', 
              marginTop: '10px' 
            }}>
             <img 
              src="/images/start-scoring1.png"
              alt="开始刷分"
              style={{ 
                maxWidth: '32%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
              <img 
              src="/images/start-scoring2.png"
              alt="开始刷分"
              style={{ 
                maxWidth: '32%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
               <img 
              src="/images/start-scoring3.png"
              alt="开始刷分"
              style={{ 
                maxWidth: '32%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            </div>
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 开始刷分界面图片
            </div>
          </div>
        </div>

        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤2: 循环买入卖出</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            
          </p>
          <ol style={{ color: '#6c757d', fontSize: '16px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>1.在手机上按"兑换" 按"确认" </li>
            <li style={{ marginBottom: '10px' }}>2.去网页上敲回车(按卖的按钮) 按钮变红 等待操作日志出现文本"手机请买入代币"</li>
            <li style={{ marginBottom: '10px' }}>3.完成最后一步的刷脸 or 指纹，发起购买支付</li>
            <li style={{ marginBottom: '10px' }}>4.等待到账</li>
          </ol>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            之后你会发现会自动帮你卖出并且转账回来。
          </p>
        </div>
        
        <div className="tutorial-note" style={{
          backgroundColor: '#e2f3ff',
          padding: '15px',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h4 style={{ color: '#0069d9', marginBottom: '10px' }}>重要注意事项:</h4>
          <p style={{ color: '#495057', fontSize: '14px' }}>
            注意按钮不要乱玩，因为真的会花钱，这个按钮按下后会尝试在后面8个区块中进行卖出。
          </p>
          <p style={{ color: '#495057', fontSize: '14px' }}>
            8次卖出失败会消耗掉0.016u，大概完全可以接受，用这些来换取一次稳定的万二磨损。
          </p>
        </div>

        <div className="tutorial-video" style={{ marginTop: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>教学视频:</h4>
          <p style={{ color: '#6c757d', fontSize: '14px', marginBottom: '10px' }}>
          </p>
          <div style={{ 
            backgroundColor: '#f0f0f0', 
            padding: '30px', 
            borderRadius: '5px',
            textAlign: 'center',
            color: '#6c757d'
          }}>
            视频播放区域
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScoringTutorial; 